import React, { useState } from "react";
import "./ContactPage.css";
import Header from "../../components/layout/header";
import Footer from "../../components/layout/footer";
import { CiMail } from "react-icons/ci";
import { IoCallOutline } from "react-icons/io5";
import { HiOutlineLocationMarker } from "react-icons/hi";

import { toast } from "react-toastify";
import axios from "axios";
import { BASE_URL } from "../../constant";
import { useNavigate } from "react-router-dom";
import FlashSale from "../Flash Sale/FlashSale";

export const ContactPage = () => {
  const navigate = useNavigate();
  const [messageReason, setMessageReason] = useState("");
  const [reqMessage, setReqMessage] = useState("");
  const [name, setName] = useState("");
  const [phoneNo, setPhoneNo] = useState("");

  const handleContactForm = async (e) => {
    e.preventDefault();

    const mobileNumberPattern = /^\d{10}$/;
    const sanitizedMessageReason = messageReason.replace(/\s+/g, "");
    const sanitizedRequestMessage = reqMessage.replace(/\s+/g, "");
    const sanitizedname = name.replace(/\s+/g, "");

    if (sanitizedname == "") {
      toast.error("Please Enter valid Name");
      return;
    }

    if (!mobileNumberPattern.test(phoneNo)) {
      toast.error("Please enter a valid 10-digit mobile number");
      return;
    }

    if (sanitizedMessageReason == "") {
      toast.error("Please Enter valid Message Reason");
      return;
    }
    if (sanitizedRequestMessage == "") {
      toast.error("Please Enter valid Message");
      return;
    }

    try {
      const userId = localStorage.getItem("userId");
      if (userId) {
        const response = await axios.post(
          `${BASE_URL}/customerMessage/add`,
          {
            userID: userId,
            customerName: sanitizedname,
            customerNo: phoneNo,
            messageReason: sanitizedMessageReason,
            customerMessage: sanitizedRequestMessage,
          },
          {
            headers: { "Content-Type": "application/json" },
          }
        );
        console.log({
          userID: userId,
          customerName: sanitizedname,
          customerNo: phoneNo,
          messageReason: sanitizedMessageReason,
          customerMessage: sanitizedRequestMessage,
        });

        const { errorMessage } = response.data;
        if (errorMessage) {
          toast.error(errorMessage);
        } else {
          toast.success("Message sent!");
          setName("");
          setPhoneNo("");
          setMessageReason("");
          setReqMessage("");
        }
      } else {
        navigate("/signup");
      }
    } catch (error) {
      console.error(error.response.data);
      toast.error("Something went wrong! Try again later");
    }
  };
  return (
    <div>
      <Header />
      <div className="contact-banner">
        <h1>Contact Us</h1>
      </div>

      <div className="contact-form-container">
        <div className="contact-form">
          <h2>Leave Us A Message</h2>
          {/* <h5>Nourishing nature, nurturing you</h5> */}
          <form method="post" onSubmit={handleContactForm}>
            <div className="form-group" id="grp1">
              <input
                type="text"
                name="name"
                value={name}
                onChange={(e) => {
                  const newValue = e.target.value.replace(/[^A-Za-z\s]/g, "");
                  setName(newValue);
                }}
                placeholder="Name"
                required
              />
              <input
                type="text"
                name="phoneNo"
                value={phoneNo}
                onChange={(e) => {
                  const enteredValue = e.target.value.replace(/\D/, "");
                  setPhoneNo(enteredValue);
                }}
                placeholder="Phone No."
                required
              />
            </div>
            <div className="form-group">
              <input
                type="text"
                name="messageReason"
                value={messageReason}
                onChange={(e) => setMessageReason(e.target.value)}
                placeholder="Subject"
                required
              />
            </div>
            <div className="form-group">
              <textarea
                name="reqMessage"
                placeholder="Message"
                value={reqMessage}
                onChange={(e) => setReqMessage(e.target.value)}
                required
              />
            </div>
            <div className="form-group">
              <input type="submit" value={"Send Message"} />
            </div>
          </form>
        </div>
      </div>
      <div className="contact-info-container">
        <div className="contact-info">
          <HiOutlineLocationMarker className="con-icon" />
          <div id="contact-text">
            <p>Address</p>
            <p className="text-[16px]">
              Shop no. 05, Krishna Niwas, opp to TBZ Jewellers, near Chitale
              Express, BCabin Road, Thane West 400602.
            </p>
          </div>
        </div>

        <div className="contact-info">
          <CiMail className="con-icon" />
          <div id="contact-text">
            <p>Email address</p>
            <p className="text-[16px]">Connect@Kharutaai.com</p>
          </div>
        </div>
        <div className="contact-info">
          <IoCallOutline className="con-icon" />
          <div id="contact-text">
            <p>Phone number</p>
            <p className="text-[16px]">+91 9833368284</p>
          </div>
        </div>
      </div>
      <div className="map-container">
        {/*<div className="timings">
          <div className="timing-btn">
            <button> Hours</button>
          </div>
          <h4>Monday - Friday</h4>
          <h5>9.00 AM - 6.30 PM</h5>
          <h4>Saturdays</h4>
          <h5>11.00 AM - 6.30 PM</h5>
          <h4>Sunday</h4>
          <h5>11.00 AM - 6.30 PM</h5>
        </div>*/}
        <div className="map">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3768.1942514146467!2d72.9710492!3d19.1867162!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7b9205ce28979%3A0xe4017790dbc5f8ec!2sPrathamesh%20Balache%20Kapade%20Baby%20Store%20Thane!5e0!3m2!1sen!2sin!4v1732195459338!5m2!1sen!2sin"
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </div>
      <Footer />
    </div>
  );
};
